const handleError = (error: Error) => {
    throw (error);
}

export default handleError;